<div class="flex-auto">
	<p-table
		#dt
		showGridlines
		stripedRows
		size="small"
		[filterDelay]="4"
		[rowHover]="true"
		[columns]="scope.table.columns"
		[multiSortMeta]="scope.table.tableLazyLoadEvent?.multiSortMeta"
		[value]="scope.table.data"
		[lazy]="scope.table.settings.lazy"
		[loading]="scope.table.loading"
		(onLazyLoad)="onLazyLoad($event)"
		[paginator]="scope.table.settings.paginator"
		[rows]="scope.table.settings.rowsPerPage"
		[rowsPerPageOptions]="scope.table.settings.rowsPerPageOptions"
		[totalRecords]="scope.table.settings.totalRecords"
		[globalFilterFields]="scope.table.settings.globalFilterFields"
		[showCurrentPageReport]="scope.table.settings.showCurrentPageReport"
		[currentPageReportTemplate]="scope.table.settings.currentPageReportTemplate"
		[sortField]="scope.table.settings.defaultSort ? scope.table.settings.defaultSort.field : ''"
		[sortOrder]="scope.table.settings.defaultSort ? scope.table.settings.defaultSort.order : 1"
		sortMode="multiple"
		styleClass="p-datatable-gridlines"
		[tableStyle]="{ 'min-width': '50rem' }">
		<ng-template pTemplate="caption" *ngIf="scope.table.settings.globalFilter">
			<div class="flex">
				<div class="flex-none">
					<ms-button
						icon="pi pi-filter-slash"
						[raised]="true"
						severity="danger"
						class="mr-3"
						(click)="clear()"></ms-button>
				</div>
				<div class="grow">
					<ms-input-text
						iconLeft="pi pi-search"
						[placeholder]="'Estou procurando...'"
						[formGroup]="formGroup"
						key="search"
						(keyup.enter)="onSearch($event)"
						(input)="onSearch($event)"></ms-input-text>
				</div>
				<div class="flex-none">
					@if (scope.table.control.new && scope.table.control.new.show) {
						<ms-button
							icon="fa-regular fa-plus"
							[raised]="true"
							severity="danger"
							class="ml-3"
							(click)="scope.table.control.new.onClick()"></ms-button>
					}
				</div>
			</div>
		</ng-template>

		<ng-template pTemplate="header" let-columns>
			<tr>
				<th
					*ngFor="let col of columns"
					[pSortableColumn]="col.field"
					[pSortableColumnDisabled]="col.sortable === false"
					[scope]="col.field"
					[style]="col.style">
					{{ col.header }}

					@if (col.searchable && col.type === 'string') {
						<p-columnFilter
							type="text"
							[field]="col.field"
							display="menu"
							matchMode="contains"></p-columnFilter>
					}

					@if (col.searchable && col.type === 'number') {
						<p-columnFilter type="numeric" [field]="col.field" display="menu"></p-columnFilter>
					}

					@if (col.searchable && col.type === 'decimal') {
						<p-columnFilter
							type="numeric"
							[minFractionDigits]="2"
							[maxFractionDigits]="2"
							[field]="col.field"
							display="menu"></p-columnFilter>
					}

					@if (col.searchable && col.type === 'date') {
						<p-columnFilter
							type="date"
							[field]="col.field"
							display="menu"
							matchMode="is"></p-columnFilter>
					}

					@if (col.searchable && col.type === 'boolean') {
						<p-columnFilter
							type="boolean"
							[field]="col.field"
							display="menu"
							matchMode="equals"></p-columnFilter>
					}
					@if (col.searchable && col.type === 'multiSelect') {
						<p-columnFilter
							[field]="col.field"
							matchMode="in"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false">
							<ng-template pTemplate="header">
								<div class="px-3 pt-3 pb-0">
									<span class="font-bold">Picker</span>
								</div>
							</ng-template>
							<!-- <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect [options]="usernames" placeholder="Any" (onChange)="filter($event.value)">
                <ng-template let-option pTemplate="item">
                  <div>
                    <span class="ml-1">{{ option }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template> -->
						</p-columnFilter>
					}
					@if (col.sortable) {
						<p-sortIcon [field]="col.field"></p-sortIcon>
					}
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-data let-columns="columns">
			<tr>
				<td *ngFor="let col of columns; let i = index" [ngStyle]="!col.style ? col.style : ''">
					<div *ngIf="col.type === 'control'" class="flex justify-center h-12">
						@if (col.control.view && col.control.view.show) {
							<button mat-icon-button (click)="col.control.view.onClick(data)">
								<mat-icon
									class="icon-size-5"
									[svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
							</button>
						}
						@if (col.control.edit && col.control.edit.show) {
							<button mat-icon-button (click)="col.control.edit.onClick(data)">
								<mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
							</button>
						}
						@if (col.control.delete && col.control.delete.show) {
							<button mat-icon-button (click)="col.control.delete.onClick(data)">
								<mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:trash'"></mat-icon>
							</button>
						}
					</div>
					@if (col.type === 'boolean') {
						<ms-input-switch
							[value]="_parseDataToValue.parse(data, col.field)"
							[onChange]="col.onChange"
							[data]="data"></ms-input-switch>
					} @else {
						{{ _parseDataToValue.parse(data, col.field) }}
					}
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage" let-columns>
			<tr>
				<td class="emptymessage" [attr.colspan]="columns.length">
					<i class="fa-light fa-circle-exclamation text-yellow-500"></i>
					{{ scope.table.settings.emptyMessage }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
